import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCompleteProfile(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#complete_profile_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#complete_profile_svg__b)" strokeWidth={20} />
      </g>
      <path
        stroke="#0C1C43"
        strokeWidth={1.5}
        d="m77.663 71.285-.572.474.572-.474c-.733-.884-1.001-2.07-.47-3.278 1.891-4.305 5.789-7.257 10.805-7.257 5.017 0 8.914 2.952 10.806 7.257.531 1.208.262 2.394-.47 3.278s-1.927 1.465-3.248 1.465H80.911c-1.32 0-2.516-.581-3.248-1.465ZM82 51.75a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z"
      />
      <defs>
        <linearGradient
          id="complete_profile_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="complete_profile_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCompleteProfile);
export default ForwardRef;
